export default __webpack_public_path__ + "static/media/arrow-left-disable.d0e0323b.svg";